import Vue from "vue";
// setup UI framework
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import lang from 'element-ui/lib/locale/lang/zh-TW';
import locale from 'element-ui/lib/locale';

Vue.use(ElementUI);
locale.use(lang);